import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getCarrierLabelsInfosRequest } from '../../api/Carrier/getCarrierLabelsInfosQuery';
import { getCarrierLabelUrlRequest } from '../../api/Carrier/getCarrierLabelUrlQuery';
import { getCarrierProductsRequest } from '../../api/Carrier/getCarrierProductsQuery';
import { getExternalCarrierCompaniesRequest } from '../../api/Carrier/getExternalCarrierCompaniesQuery';
import { getTransportMethodsRequest } from '../../api/Carrier/getTransportMethodsQuery';
import { executeSagaRequest } from '../../services';

import {
  GET_SHIPPING_LABEL,
  LOAD_CARRIERS_PRODUCTS,
  LOAD_EXTERNAL_CARRIERS,
  LOAD_LABELS,
  LOAD_TRANSPORT_METHODS,
} from './actionTypes';
import { verifyAddressWatcher } from './verifiedAddress/saga';

function* loadLabelsWorker({
  payload: { fileId },
}: {
  payload: { fileId: string };
}) {
  const meta = { fileId };

  if (!fileId) {
    yield put(LOAD_LABELS.end());

    return;
  }

  yield executeSagaRequest(
    LOAD_LABELS,
    getCarrierLabelsInfosRequest({ fileId }),
    meta,
  );
  yield put(LOAD_LABELS.end());
}

function* loadLabelsWatcher() {
  yield takeEvery<Action<{ fileId: string }>>(
    LOAD_LABELS.BASE,
    loadLabelsWorker,
  );
}

function* loadExternalCarriersWorker() {
  yield executeSagaRequest(
    LOAD_EXTERNAL_CARRIERS,
    getExternalCarrierCompaniesRequest(),
  );
  yield put(LOAD_EXTERNAL_CARRIERS.end());
}

function* loadExternalCarriersWatcher() {
  yield takeEvery(LOAD_EXTERNAL_CARRIERS.BASE, loadExternalCarriersWorker);
}

interface GetShippingLabelWorkerPayload {
  fileId: string;
  moduleDefinitionId: string;
  moduleInstanceId: string;
}

function* getShippingLabelWorker({
  payload: { fileId, moduleDefinitionId, moduleInstanceId },
}: {
  payload: GetShippingLabelWorkerPayload;
}) {
  yield executeSagaRequest(
    GET_SHIPPING_LABEL,
    getCarrierLabelUrlRequest({ fileId, moduleDefinitionId, moduleInstanceId }),
    {
      fileId,
      internalId: `${fileId}-${moduleDefinitionId}-${moduleInstanceId}`,
    },
  );

  yield put(GET_SHIPPING_LABEL.end());
}

function* getShippingLabelWatcher() {
  yield takeEvery<Action<GetShippingLabelWorkerPayload>>(
    GET_SHIPPING_LABEL.BASE,
    getShippingLabelWorker,
  );
}

function* loadTransportMethodsWorker() {
  yield executeSagaRequest(
    LOAD_TRANSPORT_METHODS,
    getTransportMethodsRequest(),
  );
  yield put(LOAD_TRANSPORT_METHODS.end());
}

function* loadTransportMethodsWatcher() {
  yield takeEvery(LOAD_TRANSPORT_METHODS.BASE, loadTransportMethodsWorker);
}

function* loadCarriersProductsWorker() {
  yield executeSagaRequest(LOAD_CARRIERS_PRODUCTS, getCarrierProductsRequest());
  yield put(LOAD_CARRIERS_PRODUCTS.end());
}
function* loadCarriersProductsWatcher() {
  yield takeEvery(LOAD_CARRIERS_PRODUCTS.BASE, loadCarriersProductsWorker);
}

export default function* mainSaga() {
  try {
    yield all([
      loadLabelsWatcher(),
      loadExternalCarriersWatcher(),
      verifyAddressWatcher(),
      loadTransportMethodsWatcher(),
      loadCarriersProductsWatcher(),
      getShippingLabelWatcher(),
    ]);
  } catch (error) {
    logCritical(error as any);
  }
}
